import { useTheme, useMediaQuery } from "@mui/material";

const useBreakpoints = (size) => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(size));
};

export default useBreakpoints;
